/* eslint-disable prefer-destructuring, new-cap */
import 'pixi-projection';
import * as mathjs from 'mathjs';

export default class SceneImage extends PIXI.Container {
  constructor(url, camera_view, matrixValues, crops, isReversed = false, param) {
    super();
    this.type = 'SceneImage';
    this.url = url;
    this.camera_view = camera_view;
    this.matrixValues = matrixValues;
    this.texture = null;
    this.reference = param.reference;
    this.referenceImageHeight = param.referenceImageHeight;
    this.global_boundaries_available = param.global_boundaries_available;
    this.crops = crops;
    this.isReversed = isReversed;

    this.loader = new PIXI.Loader();
  }

  setTexture() {
    return new Promise(async (resolve, reject) => {
      try {
        // eslint-disable-next-line no-param-reassign
        this.loader.pre((resource, next) => { resource.url += '&'; next(); });
        this.loader.add(`${this.url}`, `${this.url}`, { crossOrigin: 'anonymous' });
        this.loader.load((_, resources) => {
          const { texture } = resources[this.url];

          texture.once('update', resolve);
          texture.once('error', reject);

          this.projection_sprite = new PIXI.projection.Sprite2d(texture);
          this.texture = texture;

          if (this.reference && this.referenceImageHeight < 600) {
            this.projection_sprite.scale.set(5, 5);
          }

          if (this.matrixValues.global_matrix_values.length && this.global_boundaries_available) {
            this.applyGMatrix();
          }

          if (this.matrixValues.rectification_matrix_values.length) {
            this.applyRMatrix();
          }

          if (this.isReversed) {
            this.projection_sprite.scale.x *= -1;
            this.projection_sprite.position.x += this.projection_sprite.width;
          }

          this.addChildAt(this.projection_sprite);
          this.texture.update();
        });
      } catch (error) {
        console.warn({ rectify: error });
        reject(error);
      }
    });
  }

  applyGMatrix() {
    const { projection_sprite, matrixValues } = this;

    const GM = matrixValues.global_matrix_values;

    projection_sprite.position.y = GM[5];
    projection_sprite.position.x = GM[2];
    projection_sprite.scale.x = GM[0];
    projection_sprite.scale.y = GM[4];
  }

  applyRMatrix() {
    const { projection_sprite, matrixValues, texture } = this;

    const RM = matrixValues.rectification_matrix_values;

    const rectMatrix = [
      [RM[0], RM[1], RM[2]],
      [RM[3], RM[4], RM[5]],
      [RM[6], RM[7], RM[8]]
    ];

    const topLeft = new PIXI.Point(0, 0);
    const topRight = new PIXI.Point(texture.width, 0);
    const bottomRight = new PIXI.Point(texture.width, texture.height);
    const bottomLeft = new PIXI.Point(0, texture.height);

    const pointMatrix = [
      [topLeft.x, topRight.x, bottomRight.x, bottomLeft.x],
      [topLeft.y, topRight.y, bottomRight.y, bottomLeft.y],
      [1, 1, 1, 1]
    ];

    const result = mathjs.multiply(rectMatrix, pointMatrix);

    const [
      [m11, m12, m13, m14],
      [m21, m22, m23, m24],
      [m31, m32, m33, m34]
    ] = result;

    const topLeftTransform = new PIXI.Point(m11 / m31, m21 / m31);
    const topRightTransform = new PIXI.Point(m12 / m32, m22 / m32);
    const bottomRightTransform = new PIXI.Point(m13 / m33, m23 / m33);
    const bottomLeftTransform = new PIXI.Point(m14 / m34, m24 / m34);
    const finalPoints = [topLeftTransform, topRightTransform, bottomRightTransform, bottomLeftTransform];

    projection_sprite.proj.mapSprite(projection_sprite, finalPoints);
  }
}
